import { inject, NgModule } from '@angular/core';
import { InMemoryCache } from '@apollo/client/core';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { environment } from 'src/environments/environment';

@NgModule({
  providers: [
    provideApollo(() => ({
      cache: new InMemoryCache(),
      link: inject(HttpLink).create({ uri: environment.backEndUrl }),
    })),
  ],
})
export class GraphQLModule {}
